import { render } from "./CtrlPrev.vue?vue&type=template&id=62622495&scoped=true"
import script from "./CtrlPrev.vue?vue&type=script&lang=js"
export * from "./CtrlPrev.vue?vue&type=script&lang=js"

import "./CtrlPrev.vue?vue&type=style&index=0&id=62622495&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62622495"]])

export default __exports__